<template>
  <div class="page-container">
    <div class="stat-row">
      <div v-for="(s, i) in stat3" :key="i" class="stat-card">
        <div class="sc-num">{{ s.value }}</div>
        <div class="sc-label">{{ s.label }}</div>
      </div>
    </div>

    <div class="search-box">
      <el-tabs v-model="tab" @tab-click="onTab">
        <el-tab-pane label="绑定列表" name="bind" />
        <el-tab-pane label="历史记录" name="history" />
      </el-tabs>
      <div class="search-right">
        <el-input v-model="kw" placeholder="搜索设备编号/名称" clearable style="width:240px" @keyup.enter.native="loadData" @clear="loadData" />
        <el-button type="primary" icon="el-icon-search" @click="loadData">查询</el-button>
        <el-button v-if="tab === 'bind' && hasPermission('device_bind')" type="success" icon="el-icon-plus" @click="bindShow = true">绑定设备</el-button>
      </div>
    </div>

    <div class="table-box">
      <el-table v-if="tab === 'bind'" :data="filteredBinds" border v-loading="loading" empty-text="暂无绑定设备" height="100%">
        <el-table-column prop="name" label="车辆名称" min-width="140" />
        <el-table-column prop="sn" label="设备编号" min-width="150" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.online ? 'success' : 'info'" size="mini">{{ scope.row.online ? '在线' : '离线' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="绑定时间" min-width="170" />
        <el-table-column prop="remark" label="备注" min-width="120" />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-link v-if="hasPermission('device_rebind')" type="primary" @click="openRebind(scope.row)">换绑</el-link>
            <el-link v-if="hasPermission('device_unbind')" type="danger" @click="openUnbind(scope.row)">解绑</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-table v-else :data="filteredHistory" border v-loading="historyLoading" empty-text="暂无历史记录" height="100%">
        <el-table-column prop="name" label="车辆名称" min-width="140" />
        <el-table-column prop="sn" label="设备编号" min-width="150" />
        <el-table-column label="操作类型" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.badge === '已解绑' ? 'danger' : 'warning'" size="mini">{{ scope.row.badge }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="info" label="说明" min-width="200" />
        <el-table-column prop="op" label="操作记录" min-width="160" />
      </el-table>
    </div>

    <el-dialog title="绑定设备" :visible.sync="bindShow" width="420px" @close="bindCode=''">
      <el-form label-width="90px">
        <el-form-item label="设备编号">
          <el-input v-model="bindCode" placeholder="请输入设备一维码/编号" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="bindShow = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="doBind">确认绑定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设备换绑" :visible.sync="rebindShow" width="460px" @close="resetRebind">
      <el-form label-width="90px">
        <el-form-item label="原设备">
          <el-input :value="curItem ? curItem.sn : ''" disabled />
        </el-form-item>
        <el-form-item label="新设备编号">
          <el-input v-model="rebindCode" placeholder="请输入新设备编号" />
        </el-form-item>
        <el-form-item label="车辆名称">
          <el-input v-model="rebindName" placeholder="请输入车辆名称" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rebindShow = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="doRebind">确认换绑</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceBind, getDeviceHistory, bindDevice, unbindDevice, rebindDevice
} from '@/api/sentinel'

export default {
  name: 'DeviceIndex',
  data() {
    return {
      stat3: [],
      binds: [],
      history: [],
      tab: 'bind',
      kw: '',
      loading: false,
      historyLoading: false,
      bindShow: false,
      bindCode: '',
      rebindShow: false,
      rebindCode: '',
      rebindName: '',
      curItem: null,
      saving: false
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    filteredBinds() {
      const k = (this.kw || '').trim().toLowerCase()
      if (!k) return this.binds
      return this.binds.filter(d => (d.name || '').toLowerCase().includes(k) || (d.sn || '').toLowerCase().includes(k))
    },
    filteredHistory() {
      const k = (this.kw || '').trim().toLowerCase()
      if (!k) return this.history
      return this.history.filter(d => (d.name || '').toLowerCase().includes(k) || (d.sn || '').toLowerCase().includes(k))
    }
  },
  methods: {
    hasPermission(k) {
      return this.$store.getters.hasPermission(k)
    },
    loadData() {
      this.loading = true
      getDeviceBind().then(res => {
        if (res.code === 200) {
          const d = res.data || {}
          this.stat3 = d.stat3 || []
          this.binds = d.binds || []
          this.history = d.history || []
        }
      }).finally(() => { this.loading = false })
    },
    onTab() {
      if (this.tab === 'history') this.loadHistory()
    },
    loadHistory() {
      this.historyLoading = true
      getDeviceHistory().then(res => {
        if (res.code === 200) this.history = res.data || res || []
      }).finally(() => { this.historyLoading = false })
    },
    doBind() {
      if (!this.bindCode.trim()) return this.$message.warning('请输入设备编号')
      this.saving = true
      bindDevice(this.bindCode.trim()).then(res => {
        if (res.code === 200) {
          this.$message.success('绑定成功')
          this.bindShow = false
          this.loadData()
        }
      }).finally(() => { this.saving = false })
    },
    openUnbind(row) {
      this.curItem = row
      this.$confirm(`确认解绑设备「${row.name}（${row.sn}）」？`, '提示', { type: 'warning' }).then(() => {
        unbindDevice(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success('已解绑')
            this.loadData()
          }
        })
      }).catch(() => {})
    },
    openRebind(row) {
      this.curItem = row
      this.rebindCode = ''
      this.rebindName = row.name || ''
      this.rebindShow = true
    },
    resetRebind() {
      this.curItem = null
      this.rebindCode = ''
      this.rebindName = ''
    },
    doRebind() {
      if (!this.rebindCode.trim()) return this.$message.warning('请输入新设备编号')
      this.saving = true
      rebindDevice(this.curItem.id, { newCode: this.rebindCode.trim(), newName: this.rebindName.trim() }).then(res => {
        if (res.code === 200) {
          this.$message.success('换绑成功')
          this.rebindShow = false
          this.loadData()
        }
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.stat-row { display: flex; gap: 16px; margin-bottom: 16px; flex-wrap: wrap; }
.stat-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
  padding: 18px 24px;
  min-width: 140px;
  flex: 1;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}
.stat-card:hover { box-shadow: 0 8px 24px rgba(16, 24, 40, 0.10); transform: translateY(-2px); }
.sc-num { font-size: 26px; font-weight: 700; color: #165dff; }
.sc-label { font-size: 13px; color: #86909c; margin-top: 4px; }

/* 工具栏卡片：tabs 独立一行 + 搜索/按钮独立一行 */
.search-box {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
  margin-bottom: 16px;
  overflow: hidden;
}
.search-box .el-tabs {
  padding: 0 8px;
  border-bottom: 1px solid #F2F3F5;
}
.search-right {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
}
.search-right .el-input { width: 260px; margin-right: auto; }

.table-box {
  background: #fff;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
}
</style>
